





















import { Component, Mixins, Prop } from 'vue-property-decorator';
import QrCode from 'qrcode.vue';
import copy from 'copy-to-clipboard';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';
import { FAQItem } from '@/store/modules/faq';

@Component({
    components: {
        QrCode,
    },
})
export default class ExpandableFAQ extends Mixins(IsMobileMixin) {
    @Prop({ default: [] }) public faqItems!: FAQItem[];

    public items = 5;
    public panel = [...Array(this.items).keys()].map(_ => false);
}
